import {StatutsAcdemat} from '@/shared/dossier/enum-statuts-acdemat'

export default class StatutDossier {
  static isStatutAtteint(statutActuelDossier: string, statutAControler: string): boolean {
    const statutActuelEnum = StatutsAcdemat[statutActuelDossier]
    const statutAControlerEnum = StatutsAcdemat[statutAControler]

    return statutAControlerEnum && statutActuelEnum && statutActuelEnum.ordre >= statutAControlerEnum.ordre
  }
}
